export default "__VITE_ASSET__C8yvOyj4__"